import CRegexp from "@/src-refactor/modules/shared/model/const/regexp/regexp.const";
import { boolean, number, string } from "yup";

const alterEstateSchema = {
  want_publish_on_alterestate: boolean()
    .default(false)
    .label("Publicar en AlterEstate"),
  want_publish_on_internal_alterestate: boolean()
    .default(false)
    .label("Publicar en AlterEstate Interno"),
  garante_commission_alterestate: string()
    .isNumeric()
    .default('')
    .label("AlterEstate Comisión agente vendedor")
    .when(["want_publish_on_internal_alterestate"], {
      is: (wantInternalPublish: boolean) => wantInternalPublish,
      then: (schema: any) =>
        schema.matches(CRegexp.PERCENT, {
          excludeEmptyString: true,
          message: "El porcentaje de comisión agente vendedor no es válido"
        }),
      otherwise: (schema: any) => schema
    })
};

export default alterEstateSchema;
